module.exports = __webpack_public_path__ + "img/antes_despues_104.fd48bf5e.png";